<template>
  <router-view name="productReports" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "ProductReports",
};
</script>